import styled from "styled-components";
import { Link, Typography } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";

export const CardContainer = styled(Link)`
  font-family: "Mona-Sans";
  display: flex;
  flex-direction: column;
  flex: 1;

  border-radius: 16px;
  min-height: 100%;
  min-width: 230px;
  text-decoration: none;

  padding: 24px 18px;

  background-color: ${(props) => props?.theme.colors[props?.$bgColor]};
  @media (max-width: 900px) {
    font-size: 4vw;
    margin-bottom: 8px;

    min-height: 152px;
  }
`;

export const CardImage = styled(CardMedia)`
  border-radius: 16px 16px 0 0;
  max-width: 100%;
  height: 160px;

  @media (max-width: 900px) {
    height: 100px;
  }
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  row-gap: 32px;

  @media (max-width: 900px) {
    gap: 16px;
    justify-content: space-between;
  }
`;

export const CardTitle = styled(Typography)`
  color: ${(props) => props?.theme.colors.white};
  font-family: "Mona-Sans";
  font-size: 42.37px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -1.18px;
  text-transform: capitalize;

  margin-top: 0;
  margin-bottom: 0;
  display: block;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

export const CardBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CardBadge = styled(Typography)`
  border-radius: 16px;
  padding: 8px 16px;
  background-color: ${(props) => props?.theme.colors.white};
  color: ${(props) => props?.theme.colors?.dark};

  &:first-of-type {
    background-color: ${(props) =>
      props.$highlightColor ?? props?.theme.colors.secondaryOpaque};
    color: ${(props) => props?.theme.colors?.dark};
  }

  font-family: "Mona-Sans";
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;

  @media (max-width: 900px) {
    font-size: 12px;
  }
`;
